export default __webpack_public_path__ + "static/media/sbj-zoology.1da92c3f.svg";